var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappeningsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 37.5C4.58875 37.5 1.5 34.4112 1.5 20C1.5 5.58875 4.58875 2.5 19 2.5C33.4112 2.5 36.5 5.58875 36.5 20C36.5 34.4112 33.4112 37.5 19 37.5ZM23.9237 12.0055C23.6625 11.5305 23.1593 11.2396 22.6173 11.2503C22.0754 11.2609 21.5839 11.5713 21.3416 12.0562L15.2927 24.1538L12.6217 19.2973C12.3653 18.8312 11.8757 18.5417 11.3438 18.5417H8.79176C7.98635 18.5417 7.33345 19.1946 7.33345 20C7.33345 20.8054 7.98635 21.4583 8.79176 21.4583H10.4816L14.0765 27.9944C14.3378 28.4694 14.8409 28.7603 15.3829 28.7497C15.9249 28.7391 16.4163 28.4288 16.6586 27.9438L22.7075 15.8463L25.3785 20.7028C25.6348 21.1689 26.1245 21.4584 26.6563 21.4584H29.2084C30.0138 21.4584 30.6667 20.8055 30.6667 20.0001C30.6667 19.1947 30.0138 18.5418 29.2084 18.5418H27.5186L23.9237 12.0055Z",
    fill: "#73007D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappeningsActive);
export default __webpack_public_path__ + "static/media/happenings_active.61ab8b4f7d0c7d12d5eb8dc3222adb89.svg";
export { ForwardRef as ReactComponent };